module.exports = __webpack_public_path__ + "img/edge_restauration_cafeteria.fa4aa0be.svg";